import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { LoggingService } from './logging.service';
import { ErrorService } from './error.service';
import { NotificationService } from './notifications.service';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {

    subject = new Subject<any>();

    // Error handling is important and needs to be loaded first.
    // Because of this we should manually inject the services with Injector.
    constructor(private injector: Injector, private spinnerService: NgxSpinnerService, private router:Router) { }

    handleError(error: Error | HttpErrorResponse) {
    console.log("Error while clicking", error);

        const errorService = this.injector.get(ErrorService);
        const logger = this.injector.get(LoggingService);

        let message;
        let stackTrace;

        if (error instanceof HttpErrorResponse) {
            message = errorService.getServerMessage(error);
            stackTrace = errorService.getServerStack(error);
            let statusCode = error.status;
            if (statusCode == 500 || statusCode == 405 || statusCode == 400) {
                if (statusCode == 405 || statusCode == 400)
                    logger.logError(message, stackTrace);

            }
            else if (statusCode == 401) {
                message = "You are not authorized to perform this action.";
            }
            else if (statusCode == 404) {
                message = "Your request is not found";
                logger.logError(message, stackTrace);
            }
            else if (statusCode === 403) {
                // Navigate to the exception component
                this.router.navigate(['/unauthorized'], {
                    queryParams: {
                        code: '403',
                        message: 'Unauthorized Access',
                        helpText: message ?? 'You do not have permission to view this page.'
                    }
                });
            } 
            //Show the toaster here
            this.toastrService.error("An Error occcured while processing your request", null, { onActivateTick: true });
            this.spinnerService.hide();
        } else if(errorService.getClientMessage(error) != "No current user"){
            // Client Error
            message = errorService.getClientMessage(error);
            stackTrace = errorService.getClientStack(error);
            //Show the toaster here
            this.toastrService.error("An Error occcured while processing your request", null, { onActivateTick: true });
            // Always log Application errors
            logger.logError(message, stackTrace);
            this.spinnerService.hide();
        }
    }

    /**
 * Need to get ToastrService from injector rather than constructor injection to avoid cyclic dependency error
 * @returns {} 
 */
    private get toastrService(): ToastrService {
        return this.injector.get(ToastrService);
    }
}